import React, { useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
// import * as React from 'react';
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import "./Form.css";

function VideoUploadDialog({ onHideForm, onClose, onUpload }) {
  const [videoLink, setVideoLink] = useState("");
  const [previewImage, setThumbnailLink] = useState("");
  const [title, setTitle] = useState("");
  const [genre, setGenre] = useState("");
  const [contentRating, setAgeGroup] = useState("");
  const [releaseDate, updateDate] = useState("");

  const handleCancel = () => {
    onHideForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault(e);
    try {
      console.log("submitted");
      const res = await axios.post(
        "https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/v1/videos",
        { title, genre, previewImage, videoLink, contentRating, releaseDate }
      );
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal className="video-upload-form" show={true}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Video</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <TextField
            style={{
              marginBottom: "20px",
              padding: "13px",
              width: "400px",
              height: "30px",
              color: "white",
            }}
            id="outlined-basic"
            label="Video Link"
            variant="outlined"
            inputProps={{
              style: {
                color: "white",
                border: "1px solid white",
              },
            }}
            value={videoLink}
            onChange={(e) => setVideoLink(e.target.value)}
          />
          <TextField
            style={{
              marginBottom: "20px",
              padding: "13px",
              width: "400px",
              height: "30px",
              color: "white",
            }}
            id="outlined-basic"
            label="Thumbnail Link"
            variant="outlined"
            inputProps={{
              style: {
                color: "white",
                border: "1px solid white",
              },
            }}
            value={previewImage}
            onChange={(e) => setThumbnailLink(e.target.value)}
          />
          <TextField
            style={{
              marginBottom: "30px",
              padding: "13px",
              width: "400px",
              height: "30px",
              color: "white",
              backgroundColor: "rgb(56, 56, 56)",
            }}
            id="outlined-basic"
            label="Title"
            variant="outlined"
            inputProps={{
              style: {
                color: "white",
                border: "1px solid white",
              },
            }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <FormControl
            style={{
              width: "400px",
              marginLeft: "5px",
              marginBottom: "10px",
              padding: "7px",
              color: "white",
            }}
          >
            <InputLabel id="demo-simple-select-label">Genre</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={genre}
              inputProps={{
                style: {
                  color: "white",
                  border: "1px solid white",
                },
              }}
              style={{ color: "white", padding: "10px" }}
              label="Genre"
              onChange={(e) => setGenre(e.target.value)}
            >
              <MenuItem value="Education">Education</MenuItem>
              <MenuItem value="Sports">Sports</MenuItem>
              <MenuItem value="Comedy">Comedy</MenuItem>
              <MenuItem value="LifeStyle">LifeStyle</MenuItem>
            </Select>
          </FormControl>

          <FormControl
            style={{
              width: "400px",
              marginLeft: "5px",
              marginBottom: "10px",
              padding: "7px",
              color: "white",
            }}
          >
            <InputLabel id="demo-simple-select-label">
              Suitable age group for the clip
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              inputProps={{
                style: {
                  color: "white",
                  border: "1px solid white",
                },
              }}
              style={{ color: "white", padding: "10px" }}
              value={contentRating}
              label="Suitable age group for the clip"
              onChange={(e) => setAgeGroup(e.target.value)}
            >
              <MenuItem value="7+">7+</MenuItem>
              <MenuItem value="12+">12+</MenuItem>
              <MenuItem value="16+">16+</MenuItem>
              <MenuItem value="18+">18+</MenuItem>
            </Select>
          </FormControl>

          <input
            style={{
              backgroundColor: "rgb(56, 56, 56)",
              color: "white",
              fontWeight: "700",
              fontSize: "15px",
            }}
            variant="primary"
            id="date-field"
            type="date"
            value={releaseDate}
            name="when"
            onChange={(e) => updateDate(e.target.value)}
          ></input>
          <div id="form-btn">
            <Button
              style={{
                backgroundColor: "red",
                color: "white",
                fontWeight: "700",
                fontSize: "15px",
              }}
              variant="primary"
              onClick={handleSubmit}
              type="submit"
            >
              submit
            </Button>
            <Button
              style={{
                backgroundColor: "rgb(56, 56, 56)",
                color: "white",
                border: "none",
                fontWeight: "700",
                fontSize: "15px",
              }}
              variant="primary"
              onClick={handleCancel}
            >
              close
            </Button>
            <Button
              style={{
                backgroundColor: "rgb(56, 56, 56)",
                color: "white",
                border: "none",
                fontWeight: "700",
                fontSize: "15px",
              }}
              variant="primary"
              onClick={handleCancel}
            >
              cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default VideoUploadDialog;
